import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import './index.css';

import BusinessLayout from './layouts/BusinessLayout.jsx';
import PublicLayout from './layouts/PublicLayout.jsx';
import CandidateLayout from './layouts/CandidateLayout';

import HomePage from './pages/HomePage';
import ComingSoonPage from './pages/ComingSoonPage';
import AuthPages from './pages/auth/AuthPages';
import BusinessDashboardPage from './pages/business/BusinessDashboardPage';
import CreateTestPage from './pages/business/CreateTestPage';
import CandidatesManaPage from './pages/business/CandidatesManaPage';
import CandidateDetailPage from './pages/business/CandidateDetailPage';
import TestManagementPage from './pages/business/TestManagementPage';
import JobDetailPage from './pages/JobDetailPage';
import PreExamCheckPage from './pages/candidate/PreExamCheckPage'; // Import trang mới
import ExamPage from './pages/candidate/ExamPage';
import TestResultPage from './pages/candidate/TestResultPage';
import CreateJobPage from './pages/business/CreateJobPage';

import TestListPage from './pages/candidate/TestListPage';
import { GoogleOAuthProvider } from '@react-oauth/google'; // ✅ Import mới
import OnboardingPage from './pages/OnboardingPage';
import JobManagementPage from './pages/business/JobManagementPage';
import CompanyListPage from './pages/candidate/CompanyListPage';
import ScrollToTop from './components/ScrollToTop';
import JobListPage from './pages/candidate/JobListPage.jsx';
import CompanyDetailPage from './pages/candidate/CompanyDetailPage';

import CandidateProfilePage from './pages/candidate/CandidateProfilePage';
import CandidateCVView from './pages/business/CandidateCVView.jsx';
import JobCandidatesPage from './pages/business/JobCandidatesPage.jsx';
import SavedJobsPage from './pages/candidate/SavedJobsPage';
import FollowedCompaniesPage from './pages/candidate/FollowedCompaniesPage';
import TestHistoryPage from './pages/candidate/TestHistoryPage';
import SkillPassportPage from './public/SkillPassportPage.jsx';
import MyInterviewsPage from './pages/candidate/MyInterviewsPage.jsx';
import InterviewDetailPage from './pages/candidate/InterviewDetailPage.jsx';
import UpgradeAccountPage from './pages/UpgradeAccountPage.jsx';
import PaymentSuccess from './pages/candidate/PaymentSuccess.jsx';
import CVReviewResultPage from './pages/candidate/CVReviewResultPage';
import MockInterviewPage from './pages/candidate/MockInterviewPage.jsx';
import WhoViewedMePage from './pages/candidate/WhoViewedMePage.jsx';
import BusinessProfilePage from './pages/business/BusinessProfilePage';

import AdminLayout from './layouts/AdminLayout';
import AdminDashboard from './admin/AdminDashboard.jsx';
import UserManagement from './admin/UserManagement.jsx';
import FeedbackManagement from './admin/FeedbackManagement.jsx';
import AboutPage from './pages/AboutPage.jsx';
import NotificationPage from './pages/NotificationPage';
import './i18n';
import ProtectedRoute from './components/ProtectedRoute';
import BlogPage from './pages/BlogPage.jsx';
import BlogDetailPage from './pages/BlogDetailPage';
import BlogManagement from './admin/BlogManagement.jsx';
import PaymentManagement from './admin/PaymentManagement.jsx';
import AccountStatusListener from './pages/AccountStatusListener.jsx';
import TermsPage from './pages/TermsPage.jsx';
import PrivacyPage from './pages/PrivacyPage.jsx';
import FeedbackWidget from './components/FeedbackWidget.jsx';
import StudentCareerPage from './pages/student/StudentCareerPage';
import StudentDashboard from './pages/student/StudentDashboard.jsx';
import PersonalityTestPage from './pages/student/PersonalityTestPage';
import MajorWikiPage from './pages/student/MajorWikiPage';
import UniRoadmapPage from './pages/student/UniRoadmapPage';
import AdminJobManager from './admin/AdminJobManager.jsx';
import AdminAboutSettings from './admin/AdminAboutSettings.jsx';
import EventRegisterPage from './pages/EventRegisterPage';
import ChangePasswordPage from './pages/auth/ChangePasswordPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
const GOOGLE_CLIENT_ID = "231395174216-l637p80r5e1ck365codlaj3vaq17tfo7.apps.googleusercontent.com"; // ⚠️ Bạn cần lấy ID này từ Google Cloud Console

// Cấu hình Chakra Theme
const config = { initialColorMode: 'light', useSystemColorMode: false };
const theme = extendTheme({ config });


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <ScrollToTop />
          <AccountStatusListener />
          <FeedbackWidget />
          <Routes>


            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/jobs" element={<JobListPage />} />
              <Route path="/jobs/:id" element={<JobDetailPage />} />
              <Route path="/tests" element={<TestListPage />} />
              <Route path="/companies" element={<CompanyListPage />} />
              <Route path="/companies/:id" element={<CompanyDetailPage />} />
              <Route path="/upgrade-account" element={<UpgradeAccountPage />} />
              <Route path="/payment-success" element={<UpgradeAccountPage />} />

              <Route path="/passport/:id" element={<SkillPassportPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogDetailPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/event-gift" element={<EventRegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
            </Route>

            {/* Auth Routes (Không cần Layout hoặc Layout riêng) */}
            <Route path="/login" element={<AuthPages />} />
            <Route path="/register-select" element={<AuthPages />} />
            <Route path="/register-business" element={<AuthPages />} />
            <Route path="/register-candidate" element={<AuthPages />} />

            <Route path="/onboarding" element={<OnboardingPage />} />

            {/* 2. BUSINESS ROUTES (Có Layout) */}
            <Route element={<ProtectedRoute allowedRoles={['business']} />}>
              <Route path="/business" element={<BusinessLayout />}>
                <Route path="dashboard" element={<BusinessDashboardPage />} />
                <Route path="candidates/:id/cv" element={<CandidateCVView />} />
                <Route path="jobs/new" element={<CreateJobPage />} />
                <Route path="tests" element={<TestManagementPage />} />
                <Route path="jobs" element={<JobManagementPage />} />
                <Route path="jobs/edit/:id" element={<CreateJobPage />} />
                <Route path="profile" element={<BusinessProfilePage />} />
                <Route path="upgrade-account" element={<UpgradeAccountPage />} />

                <Route path="candidates" element={<CandidatesManaPage />} />
                <Route path="candidates/:id" element={<CandidateDetailPage />} />
                <Route path="settings" element={<ComingSoonPage />} />
                <Route path="settings/billing" element={<ComingSoonPage />} />
                <Route path="settings/security" element={<ComingSoonPage />} />
                <Route path="jobs/:jobId/candidates" element={<JobCandidatesPage />} />
                <Route path="notifications" element={<NotificationPage />} />
              </Route>
            </Route>



            <Route element={<ProtectedRoute allowedRoles={['candidate']} />}>
              <Route path="/candidate" element={<CandidateLayout />}>
                <Route path="tests" element={<TestListPage />} />
                <Route path="tests/:id" element={<PreExamCheckPage />} />
                <Route path="test-result" element={<TestResultPage />} />
                <Route path="profile" element={<CandidateProfilePage />} />
                <Route index element={<HomePage />} />
                <Route path="notifications" element={<NotificationPage />} />
                <Route path="saved-jobs" element={<SavedJobsPage />} />
                <Route path="following" element={<FollowedCompaniesPage />} />
                <Route path="test-history" element={<TestHistoryPage />} />
                <Route path="my-interviews" element={<MyInterviewsPage />} />
                <Route path="interviewed/:id" element={<InterviewDetailPage />} />
                <Route path="upgrade-account" element={<UpgradeAccountPage />} />
                <Route path="payment-success" element={<PaymentSuccess />} />
                <Route path="cv-review-result" element={<CVReviewResultPage />} />
                <Route path="mock-interview" element={<MockInterviewPage />} />
                <Route path="who-viewed-me" element={<WhoViewedMePage />} />
                <Route path="blog" element={<BlogPage />} />
                <Route path="jobs" element={<JobListPage />} />
                <Route path="jobs/:id" element={<JobDetailPage />} />
                <Route path="tests" element={<TestListPage />} />
                <Route path="companies" element={<CompanyListPage />} />
                <Route path="blog" element={<BlogPage />} />
                <Route path="blog/:slug" element={<BlogDetailPage />} />
                <Route path="companies/:id" element={<CompanyDetailPage />} />
                <Route path="change-password" element={<ChangePasswordPage />} />
              </Route>

            </Route>

            {/* URL: /candidate/tests */}

            <Route path="/business/tests/new" element={<CreateTestPage />} />
            <Route path="/business/tests/edit/:id" element={<CreateTestPage />} />

            <Route path="/candidate/exam/:id" element={<ExamPage />} />


            {/* 404 Fallback */}
            <Route path="*" element={<ComingSoonPage />} />
            <Route path="/student" element={<StudentDashboard />} />
            <Route path="/student/career-path" element={<StudentCareerPage />} />

            {/* (Các tính năng khác chưa làm thì có thể trỏ tạm về Dashboard hoặc trang "Coming Soon") */}
            <Route path="/student/personality-test" element={<PersonalityTestPage />} />
            <Route path="/student/major-wiki" element={<MajorWikiPage />} />
            <Route path="/student/uni-roadmap" element={<UniRoadmapPage />} />

            <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
              <Route path="/admin" element={<AdminLayout />}>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="candidates" element={<UserManagement role="candidate" />} />
                <Route path="businesses" element={<UserManagement role="business" />} />
                <Route path="feedbacks" element={<FeedbackManagement />} />
                <Route path="blogs" element={<BlogManagement />} />
                <Route path="payments" element={<PaymentManagement />} />
                <Route path="jobs" element={<AdminJobManager />} />
                <Route path="about-settings" element={<AdminAboutSettings />} />
                {/* Có thể thêm JobManagement sau */}
              </Route>
            </Route>

          </Routes>
        </BrowserRouter>
      </ChakraProvider>
    </GoogleOAuthProvider>

  </React.StrictMode>
);